module.exports = __webpack_public_path__ + "static/banner.a1f8059e.png";